import { inject, Injectable } from '@angular/core'

import { MsalService } from '@azure/msal-angular'

/**
 * Single-flight MSAL initialization.
 *
 * `PublicClientApplication.initialize()` only flips its internal `initialized` flag once it has
 * finished awaiting, so two overlapping calls both run the full startup and MSAL then reports a
 * spurious "there is already an instance of MSAL.js in the window" warning. That overlap is real
 * here: services built while Angular resolves the `ErrorHandler` run before the app initializer.
 *
 * Injecting this root singleton and awaiting `ready` guarantees exactly one initialize() call.
 */
@Injectable({ providedIn: 'root' })
export class MsalInitService {
  private readonly authService = inject(MsalService)

  readonly ready: Promise<void> = this.authService.instance.initialize()
}
